<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ $t('letrex.card.actions') }}</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <output-actions-menu
            :can-export="canExport"
            :can-send="canSend"
            :puzzle-id="model.id"
            success-key="letrex.alert.sendSuccess"
            error-key="letrex.alert.sendError"
            @export="toggleModal"
          />

          <p
            v-if="!canExport"
            class="text-muted mb-1 small"
            style="color: #6c757d !important"
          >
            {{ $t('letrex.sidebar.exportHint') }}
          </p>

          <d-button
            @click.prevent="generate()"
            class="btn-outline-dark btn-block"
          >
            {{ $t('letrex.button.generate') }}
          </d-button>

          <d-button
            @click.prevent="clear()"
            class="btn-danger btn-block mt-2"
          >
            {{ $t('shared.actions.clear') }}
          </d-button>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
    <d-card-footer
      class="border-top d-flex flex-column flex-xl-row justify-content-around"
    >
      <d-button
        @click="save"
        type="button"
        class="btn-primary mb-3 mb-xl-0 col-xl-5"
      >
        {{ $t('shared.actions.save') }}
      </d-button>
      <d-button class="btn-secondary text-white col-xl-5" @click="goBack">
        {{ $t('shared.actions.back') }}
      </d-button>
    </d-card-footer>
    <export-file-modal
      gameType="letrex"
      :items="[model]"
      :fileName="model.name || $t('letrex.sidebar.defaultFileName')"
    />
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import ExportFileModal from '_common/shared/ExportFileModal.vue';
import OutputActionsMenu from '_shared/OutputActionsMenu.vue';
import { MODEL } from './LetrexModel';

export default {
  name: 'letrex-sidebar-actions',
  props: {
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  components: { ExportFileModal, OutputActionsMenu },
  computed: {
    canExport() {
      const { hasChanges } = this.$store.state.letrex;
      const isPageCreation = !this.$route.params.puzzleId;

      if (isPageCreation) return false;
      if (hasChanges) return false;

      return Array.isArray(this.model?.table) && this.model.table.length > 0;
    },
    canSend() {
      return this.canExport && !!this.model.id;
    },
  },
  methods: {
    ...mapActions(['setToggle']),
    goBack() {
      this.$router.go(-1);
    },
    generate() {
      this.$emit('generate', this.model);
    },
    clear() {
      this.$emit('clear', this.model);
    },
    save() {
      this.$emit('save', this.model);
    },
    toggleModal() {
      this.setToggle({ type: 'export_file_modal', bool: true });
    },
  },
};
</script>
